import axiosInstance from '../../components/api/axiosInstance';

export const workspaceSearchService = {
  // params: { from, to } as YYYY-MM-DD (optional)
  getUsage: (params = {}) =>
    axiosInstance.get('/api/admin/workspace-search/usage', { params }).then((r) => r.data),

  getSettings: () =>
    axiosInstance.get('/api/admin/workspace-search/settings').then((r) => r.data),

  // settings: { searchEnabled?, disabledSources? }
  updateSettings: (settings) =>
    axiosInstance.put('/api/admin/workspace-search/settings', settings).then((r) => r.data),
};
